/* eslint-disable jira/naming/disallow-filenames */
import type { CookieCircuitBreakerConfig } from '@jira/platform__routing-route-types/src/JiraSpaRoute.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import killswitch from '@jira/platform__utils-feature-gates-killswitch';

export function getIssueCircuitBreaker(): CookieCircuitBreakerConfig {
	return {
		isSetCookieEnabled: true,
		isMonitoringEnabled: true,
		isCircuitBreakerEnabled: !killswitch('issue-view-cookie-cb'),
		cookieKey: 'iss',
		windowSize: 5,
		threshold: 0.7,
		keepOpenCount: 50,
		halfOpenForCount: 5,
	};
}
